import { render, staticRenderFns } from "./NewDMultiImageUploadPreview.vue?vue&type=template&id=6c047c3a&"
import script from "./NewDMultiImageUploadPreview.vue?vue&type=script&lang=js&"
export * from "./NewDMultiImageUploadPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewDMultiImageUploadPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports